import React from 'react';

const StatusCircle: React.FC<{
  value: boolean;
  pending: boolean;
}> = ({ value, pending }) => {

  const classStatus = () => {
    if (pending)
      return 'bg-pending';

    return value ? 'bg-primary' : 'bg-danger';
  };

  return (
    <div
      className={`${classStatus()}`}
      style={{ height: 12, width: 12, borderRadius: '50%' }}
    />
  );
};

export default StatusCircle;
